import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';

enum PageView {
  Unauthorized = 0,
  SignInError = 1
}

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized-error.component.html',
  styleUrls: ['./unauthorized-error.component.scss']
})
export class UnauthorizedErrorComponent implements OnInit, OnDestroy {
  pageView: string = PageView[PageView.Unauthorized];
  url: string;
  error: string;
  errorDescription: string;
  uri: string;
  state: string;
  memberUnauthorized: string;
  unauthorizedPageName: string;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.url = this.router.url;
    this.url = this.url.includes('?') ? this.url.substring(0, this.url.indexOf('?')) : this.url;
    this.pageView = this.getPageView(this.url);
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      distinctUntilChanged(),
      takeUntil(this.ngUnsubscribe)
    ).subscribe((event: NavigationEnd) => {
      this.url = event.url;
      this.pageView = this.getPageView(this.url);
    });

    this.route.queryParams.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe(params => {
      this.error = params['error'];
      this.errorDescription = params['description'];
      this.uri = params['uri'];
      this.state = params['state'];
      this.memberUnauthorized = params['member'];
      this.unauthorizedPageName = params['pageName'] || 'view member details';
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getPageView(routeUrl: string): string {
    switch (routeUrl) {
      case '/sign-in-error':
        return PageView[PageView.SignInError];
      case '/unauthorized':
        return PageView[PageView.Unauthorized];
      default:
        return PageView[PageView.Unauthorized];
    }
  }

  get hasErrorInfo() {
    return this.error || this.errorDescription || this.state || this.uri;
  }
}
